import React from "react";
import { Typography } from "@material-ui/core";
import styles from "./Row.module.scss";

interface Props {
  label: string;
  value: React.ReactNode;
  showLine?: boolean;
}

const Row = ({ label, value, showLine = true }: Props) => {
  return (
    <div className={styles.row}>
      <Typography variant="caption">{label}</Typography>
      {showLine && <div className={styles.rowDivider} />}
      <Typography variant="body2">{value}</Typography>
    </div>
  );
};

export default Row;
